"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceServerPutRequest = exports.VoiceServerPostRequest = exports.VoiceServer = exports.VoiceRegionPutRequest = exports.VoiceRegionPostRequest = exports.VoiceRegion = exports.OutboundRoutePutRequest = exports.OutboundRoutePostRequest = exports.OutboundRoute = exports.OutboundProxyPutRequest = exports.OutboundProxyPostRequest = exports.OutboundProxy = void 0;
const OutboundProxy_1 = require("./OutboundProxy");
exports.OutboundProxy = OutboundProxy_1.default;
const OutboundProxyPostRequest_1 = require("./OutboundProxyPostRequest");
exports.OutboundProxyPostRequest = OutboundProxyPostRequest_1.default;
const OutboundProxyPutRequest_1 = require("./OutboundProxyPutRequest");
exports.OutboundProxyPutRequest = OutboundProxyPutRequest_1.default;
const OutboundRoute_1 = require("./OutboundRoute");
exports.OutboundRoute = OutboundRoute_1.default;
const OutboundRoutePostRequest_1 = require("./OutboundRoutePostRequest");
exports.OutboundRoutePostRequest = OutboundRoutePostRequest_1.default;
const OutboundRoutePutRequest_1 = require("./OutboundRoutePutRequest");
exports.OutboundRoutePutRequest = OutboundRoutePutRequest_1.default;
const VoiceRegion_1 = require("./VoiceRegion");
exports.VoiceRegion = VoiceRegion_1.default;
const VoiceRegionPostRequest_1 = require("./VoiceRegionPostRequest");
exports.VoiceRegionPostRequest = VoiceRegionPostRequest_1.default;
const VoiceRegionPutRequest_1 = require("./VoiceRegionPutRequest");
exports.VoiceRegionPutRequest = VoiceRegionPutRequest_1.default;
const VoiceServer_1 = require("./VoiceServer");
exports.VoiceServer = VoiceServer_1.default;
const VoiceServerPostRequest_1 = require("./VoiceServerPostRequest");
exports.VoiceServerPostRequest = VoiceServerPostRequest_1.default;
const VoiceServerPutRequest_1 = require("./VoiceServerPutRequest");
exports.VoiceServerPutRequest = VoiceServerPutRequest_1.default;
